export const DEFAULT_CLAIM_FORM_VALUE = {
  partialClaim: false,
  patientMemberType: undefined,
  currency: 'HKD',
  firstClaimCurrency: 'HKD',
  receiptAmounts: [],
  receipts: [],
  referralLetters: [],
  otherDocuments: [],
  prevClaimSettlements: [],
};
